export enum EnumEstadoLoteLiquidacion {
  Solicitado = 1,
  EnCurso = 2,
  Finalizado = 3,
  Error = 4
}
